import { KeyCreatorParams } from 'ag-grid-community';
import assertNever from 'assert-never';

import { DeviceClaimResult } from '@shure/cloud/shared/models/devices';
import { compareStrings } from '@shure/shared/angular/ui/comparators/string';
import { ProgressCellData, ProgressStatus } from '@shure/shared/angular/ui/components/ag-grid-next';

import { mapProgressStatusToTranslocoKey } from './mappers/map-progress-status-to-transloco-key';

/**
 * Extends the shared ProgressCellData with an id field to use for comparisons
 */
export interface ClaimStatusCellData extends ProgressCellData {
	id: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function claimStatusKeyCreator(params: KeyCreatorParams<any, ClaimStatusCellData>): string {
	return params.value?.status ?? ProgressStatus.InProgress;
}

export function claimStatusCellDataComparator(a: ClaimStatusCellData, b: ClaimStatusCellData): number {
	return compareStrings(
		JSON.stringify(makeComparableClaimStatusCellData(a)),
		JSON.stringify(makeComparableClaimStatusCellData(b))
	);
}

function makeComparableClaimStatusCellData(obj: ClaimStatusCellData): Omit<ClaimStatusCellData, 'id'> {
	const { id, ...rest } = obj;
	return rest;
}

export function mapClaimResultToProgressCellData(result: DeviceClaimResult): ProgressCellData {
	switch (result) {
		case 'in-progress':
			return {
				status: ProgressStatus.InProgress,
				statusTextKey: mapProgressStatusToTranslocoKey(ProgressStatus.InProgress)
			};
		case 'success':
			return {
				status: ProgressStatus.Success,
				statusTextKey: mapProgressStatusToTranslocoKey(ProgressStatus.Success)
			};
		case 'error':
			return {
				status: ProgressStatus.Error,
				statusTextKey: mapProgressStatusToTranslocoKey(ProgressStatus.Error)
			};
		default:
			assertNever(result);
	}
}
